NLMK.fusionTables = {};

/**
 *
 * @type {Function[]}
 */
const onFusionTablesReadyCallbacks = [];

/**
 *
 * @type {boolean}
 */
let isFusionTablesReady = false;

/**
 *
 * @type {boolean}
 */
let isFusionTablesRequired = false;

/**
 *
 * @param {Object} data
 */
window.fusionTablesRegister = function fusionTablesRegister(data) {
    isFusionTablesReady = true;

    NLMK.fusionTables.data = data;

    onFusionTablesReadyCallbacks.forEach(function eachCallback(callback) {
        if (!callback instanceof Function) {
            throw new Error('!callback instanceof Function');
        }

        callback(data);
    });

    onFusionTablesReadyCallbacks.length = 0;
};

/**
 *
 * @param {Function} callback
 */
NLMK.fusionTables.onReady = function onFusionTablesReady(callback) {
    if (isFusionTablesReady) {
        callback(NLMK.fusionTables.data);
    }

    else {
        onFusionTablesReadyCallbacks.push(callback);

        if (!isFusionTablesRequired) {
            requireFusionTables();
        }
    }
};

NLMK.fusionTables.constructNewCoordinates = function constructNewCoordinates(polygon) {
    const newCoordinates = [];
    const coordinates = polygon['coordinates'][0];

    for (var coordinate in coordinates) {
        if (coordinates.hasOwnProperty(coordinate)) {
            newCoordinates.push(
                new google.maps.LatLng(coordinates[coordinate][1], coordinates[coordinate][0]));
        }
    }

    return newCoordinates;
};

function requireFusionTables() {
    const script = document.createElement('script');
    const url = ['https://www.googleapis.com/fusiontables/v1/query?'];
    const query = 'SELECT name, kml_4326 FROM 1foc3xO9DyfSIF6ofvN0kp2bxSfSeKog5FbdWdQ';
    const encodedQuery = encodeURIComponent(query);

    url.push('sql=');
    url.push(encodedQuery);
    url.push('&callback=fusionTablesRegister');
    url.push('&key=' + NLMK.FusionTablesApiKey);

    script.src = url.join('');

    document.body.appendChild(script);

    isFusionTablesRequired = true;
}

/**
 *
 * @param {google.maps.Map} GoogleMap
 * @param {[]} regions
 * @returns {Array} regions
 */
NLMK.fusionTables.reDrawGoogleMapCountries = function (GoogleMap, regions = []) {
    const rows = NLMK.fusionTables.data.rows;
    const countryNames = [];
    const regionByCountry = {};

    regions.forEach(region => {
        region.countries.forEach(country => {
            countryNames.push(country.name);

            region.polygons = [];

            regionByCountry[country.name] = region;
        });
    });

    for (let rowIndex in rows) {
        if (rows.hasOwnProperty(rowIndex) && rows[rowIndex][0] !== 'Antarctica') {
            let pathCoordinates = [];
            const geometries = rows[rowIndex][1]['geometries'];

            if (geometries) {
                for (const geometry in geometries) {
                    if (geometries.hasOwnProperty(geometry)) {
                        pathCoordinates.push(NLMK.fusionTables.constructNewCoordinates(geometries[geometry]));
                    }
                }
            }

            else {
                pathCoordinates = NLMK.fusionTables.constructNewCoordinates(rows[rowIndex][1]['geometry']);
            }

            const countryName = rows[rowIndex][0];

            // console.log(countryName)

            const CountryPolygon = new google.maps.Polygon({
                paths: pathCoordinates,
                strokeColor: '#B6C4D1',
                strokeOpacity: 0,
                strokeWeight: 0,
                fillColor: '#B6C4D1',
                fillOpacity: 1,
                name: countryName
            });

            const isCountryNameFound = -1 !== countryNames.indexOf(countryName);


            if (isCountryNameFound) {
                const region = regionByCountry[countryName];
                const polygons = region.polygons;

                polygons.push(CountryPolygon);

                region.fill = () => {
                    polygons.forEach(polygon => {
                        polygon.setOptions({
                            fillColor: NLMK.maps.countryColors.fill
                        });
                    });
                };

                region.unfill = () => {
                    polygons.forEach(polygon => {
                        polygon.setOptions({
                            fillColor: NLMK.maps.countryColors.default
                        });
                    });
                };

                // google.maps.event.addListener(CountryPolygon, 'mouseover', function () {
                //     region.fill();
                // });
                //
                // google.maps.event.addListener(CountryPolygon, 'mouseout', function () {
                //     region.unfill();
                // });

                google.maps.event.addListener(CountryPolygon, 'click', function () {
                    console.log(countryName)
                });
            }

            CountryPolygon.setMap(GoogleMap);
        }
    }

    return regions;
};

/*
Afghanistan
United Arab Emirates
Burkina Faso
Bangladesh
Congo (Kinshasa)
Cuba
Czech Rep.
Denmark
Ethiopia
Guinea Bissau
Eq. Guinea
Croatia
Indonesia
Iran
Jordan
Kazakhstan
Cambodia
Laos
New Zealand
Papua New Guinea
Russia
Rwanda
Somalia
Serbia
Trinidad and Tobago
Tunisia
Yemen
Zimbabwe
Angola
Armenia
Fr. S. and Antarctic Lands
Burundi
Bosnia and Herz.
Colombia
Cyprus
Ecuador
Eritrea
Honduras
Kuwait
Sri Lanka
Lithuania
Moldova
Nicaragua
Nepal
Panama
Portugal
Qatar
Romania
Solomon Is.
Slovenia
Vietnam
Albania
Australia
Azerbaijan
Belgium
Switzerland
Congo (Brazzaville)
Costa Rica
N. Cyprus
France
Guyana
Luxembourg
Latvia
Madagascar
Mali
Mozambique
Saudi Arabia
Slovakia
Syria
Thailand
Uzbekistan
South Africa
Argentina
Brunei
Botswana
Canada
China
Ivory Coast
Germany
Egypt
Spain
Finland
Gambia
Greenland
Iraq
S. Korea
Kosovo
Malaysia
Namibia
Norway
N. Korea
Somaliland
Turkmenistan
Taiwan
Tanzania
Venezuela
Vanuatu
Benin
Belarus
Belize
Bolivia
Brazil
Bhutan
Central African Rep.
Chile
Fiji
Georgia
Hungary
Ireland
Italy
Jamaica
Japan
Kyrgyzstan
Morocco
Macedonia
Malawi
Suriname
Sweden
East Timor
Turkey
United States
Austria
Cameroon
Djibouti
Dominican Rep.
Falkland Is.
Gabon
United Kingdom
Ghana
Greece
Iceland
Lebanon
Libya
Lesotho
Mexico
Myanmar
Montenegro
Mongolia
Niger
Nigeria
Netherlands
Sudan
S. Sudan
Senegal
Sierra Leone
El Salvador
Chad
Tajikistan
Uganda
Ukraine
Uruguay
Zambia
Bulgaria
Algeria
Estonia
Haiti
India
Kenya
Liberia
Mauritania
New Caledonia
Pakistan
Peru
Philippines
Paraguay
Swaziland
West Bank
Bahamas
Guinea
Guatemala
Israel
Oman
Poland
Puerto Rico
W. Sahara
Togo
 */



// WEBPACK FOOTER //
// ./js/main/package/fusion-tables.js